import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const ConfigMigrationRoutes: RouteBundle = {
  domain: 'config-migration',
  routes: [
    {
      urlPattern: 'config-migration',
      handler: EditorRoutes.configMigrationPage.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'config-migration/import',
      handler: EditorRoutes.configMigrationImport.bind(EditorRoutes),
      legacy: false,
    },
    {
      urlPattern: 'config-migration/export',
      handler: EditorRoutes.configMigrationExport.bind(EditorRoutes),
      legacy: false,
    },
  ],
};
